import React from "react";
const Asterik = ({ hidden = false }) => {
    return (React.createElement("span", { hidden: hidden, style: { color: "red", marginLeft: "2px" } }, "*"));
};
export default Asterik;
